// eslint-disable-next-line import/prefer-default-export
const COLORS = {
    PRIMARY: 'var(--primary, #2095d5)',
    SECONDARY: 'var(--secondary, #304755)',
    MEDIUMGREY: 'var(--mediumGrey, #c7c7c7)',
    LIGHTGREY: 'var(--lightGrey, #f1f1f1)',
    SUCCESS: 'var(--success, #28a745)',
    DANGER: 'var(--danger, #dc3445)',
    WARNING: 'var(--warning, #ffc105)',
    INFO: 'var(--info, #17a2b8)',
    NEUTRAL: 'var(--neutral, #888888)',
    WHITE: '#fff',
};

export { COLORS };
//# sourceMappingURL=constants.js.map
